// ###### IMPORTS
import React from 'react';
import CardViewMode from './viewComponents/CardViewMode';
import CardClusters from './viewComponents/CardClusters';

// ###### MAIN COMPONENT
const TabNotepadSettings = ({ clusters, isClustersLoading, onClusterCreate, onClusterUpdate, onClusterDelete }) => {
  return (
    <div className="p-0 flex flex-col gap-2 w-full mt-2">
      <CardViewMode />
      <CardClusters 
        clusters={clusters}
        isLoading={isClustersLoading}
        onCreateCluster={onClusterCreate}
        onUpdateCluster={onClusterUpdate}
        onDeleteCluster={onClusterDelete}
      />
    </div>
  );
};

export default TabNotepadSettings;
